import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import NabBar from '../../components/Navbar/NabBar';
import Footer from '../../components/Footer/Footer';
import useAxios from '../../helpers/Hooks/useAxios';
import { URLS } from '../../helpers/URLS';
import Wmlogo from '../../assets/images/brand/workhub-logo-light.svg';
import './OrganizationRegister.scss';

const OrganizationRegister = () => {
  const navigate = useNavigate();
  const { fetchData } = useAxios();

  const [currentStep, setCurrentStep] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState('Free');

  const [formData, setFormData] = useState({
    // Step 1: Contact Details
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    // Step 2: Organisation Details
    companyName: '',
    organisationEmail: '',
    numberOfEmps: '',
    location: '',
    websiteUrl: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateStep = (step) => {
    if (step === 1) {
      const { firstName, lastName, email, mobileNumber } = formData;
      if (!firstName.trim() || !lastName.trim() || !email.trim() || !mobileNumber.trim()) {
        toast.error('Please fill in all fields before moving to the next step.');
        return false;
      }
    } else if (step === 2) {
      const { companyName, organisationEmail, numberOfEmps, location, websiteUrl } = formData;
      if (
        !companyName.trim() ||
        !organisationEmail.trim() ||
        !String(numberOfEmps).trim() ||
        !location.trim() ||
        !websiteUrl.trim()
      ) {
        toast.error('Please fill in all fields before moving to the next step.');
        return false;
      }
    } else if (step === 3) {
      if (!selectedPlan) {
        toast.error('Please select a plan before completing registration.');
        return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    if (!validateStep(currentStep)) return;
    if (currentStep < 3) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleRegister = async () => {
    if (!validateStep(currentStep)) return;
    const payload = {
      companyName: formData.companyName,
      organisationEmail: formData.organisationEmail,
      organisationLocation: formData.location,
      numberOfEmps: formData.numberOfEmps ? Number(formData.numberOfEmps) : 0,
      mobileNum: formData.mobileNumber,
      websiteUrl: formData.websiteUrl,
      planOpted: selectedPlan,
      contactinfo: {
        FirstName: formData.firstName,
        LastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobileNumber
      }
    };

    try {
      const resp = await fetchData({
        url: URLS.createOrg,
        method: 'post',
        body: payload
      });

      if (resp && (resp._id || resp.companyName || resp.status === 200)) {
        toast.success('Registered successfully!');
        navigate('/');
      } else if (resp && resp.message) {
        toast.error(resp.message);
      } else {
        toast.success('Registered successfully!');
        navigate('/');
      }
    } catch (err) {
      toast.error('Registration failed. Please try again.');
    }
  };

  const plans = [
    {
      name: 'Free',
      duration: '60 Days',
      users: '200',
      price: '$0'
    },
    {
      name: 'Pro',
      duration: '3 Months',
      users: '350',
      price: '$250'
    },
    {
      name: 'Max',
      duration: '6 Months',
      users: '500',
      price: '$500'
    }
  ];

  return (
    <div>
      <NabBar />
      <div className="org-register-page">
        <div className="org-register-card">
          <div className="brand-logo-header">
            <img src={Wmlogo} alt="WorkHub" />
          </div>
          <h2 className="org-title">Organization Registration</h2>
          <p className="org-subtitle">Register your organization to get started</p>

          <div className="steps-container">
            <div className="step-indicators">
              {/* Step 1 */}
              <div className="step-item">
                <div
                  className={`step-icon-circle ${
                    currentStep === 1
                      ? 'active'
                      : currentStep > 1
                      ? 'completed'
                      : ''
                  }`}
                >
                  {currentStep > 1 ? '✓' : '1'}
                </div>
                <span
                  className={`step-label ${currentStep >= 1 ? 'active' : ''}`}
                >
                  Contact<br />Details
                </span>
              </div>

              {/* Step 2 */}
              <div className="step-item">
                <div
                  className={`step-icon-circle ${
                    currentStep === 2
                      ? 'active'
                      : currentStep > 2
                      ? 'completed'
                      : ''
                  }`}
                >
                  {currentStep > 2 ? '✓' : '2'}
                </div>
                <span
                  className={`step-label ${currentStep >= 2 ? 'active' : ''}`}
                >
                  Organisation<br />Details
                </span>
              </div>

              {/* Step 3 */}
              <div className="step-item">
                <div
                  className={`step-icon-circle ${
                    currentStep === 3 ? 'active' : ''
                  }`}
                >
                  3
                </div>
                <span
                  className={`step-label ${currentStep === 3 ? 'active' : ''}`}
                >
                  select<br />Plan
                </span>
              </div>
            </div>

            <div className="step-form-content">
              {currentStep === 1 && (
                <div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      placeholder="First Name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder="Last Name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Mobile Number"
                    />
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      placeholder="Organization Name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="organisationEmail"
                      value={formData.organisationEmail}
                      onChange={handleInputChange}
                      placeholder="Organization Email"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      name="numberOfEmps"
                      value={formData.numberOfEmps}
                      onChange={handleInputChange}
                      placeholder="Number of Employees"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="Location"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="websiteUrl"
                      value={formData.websiteUrl}
                      onChange={handleInputChange}
                      placeholder="Website Url"
                    />
                  </div>
                </div>
              )}

              {currentStep === 3 && (
                <div>
                  <p style={{ fontSize: '13px', color: '#475569', marginBottom: '12px', fontWeight: '500' }}>Select a Plan:</p>
                  <div className="plans-grid">
                    {plans.map((plan) => (
                      <div
                        key={plan.name}
                        className={`plan-card ${
                          selectedPlan === plan.name ? 'selected' : ''
                        }`}
                        onClick={() => setSelectedPlan(plan.name)}
                      >
                        <div className="plan-header">
                          <span className="plan-name">{plan.name}</span>
                          <div
                            className={`radio-circle ${
                              selectedPlan === plan.name ? 'selected' : ''
                            }`}
                          />
                        </div>
                        <div className="plan-details">
                          <div className="detail-row">
                            <span>Duration: {plan.duration}</span>
                          </div>
                          <div className="detail-row">
                            <span>Users: {plan.users}</span>
                          </div>
                          <div className="detail-row">
                            <span>Price: {plan.price}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="step-actions">
              <button
                type="button"
                className="btn-back"
                onClick={handleBack}
                disabled={currentStep === 1}
                style={{ visibility: currentStep === 1 ? 'hidden' : 'visible' }}
              >
                Back
              </button>
              {currentStep < 3 ? (
                <button
                  type="button"
                  className="btn-next"
                  onClick={handleNext}
                >
                  Next
                </button>
              ) : (
                <button
                  type="button"
                  className="btn-register"
                  onClick={handleRegister}
                >
                  Register
                </button>
              )}
            </div>
          </div>

          <div className="social-auth-section">
            <p className="signin-link-text">
              Already have an account? <NavLink to="/login">Sign In</NavLink>
            </p>
            <div className="divider">
              <span>OR</span>
            </div>
            <p className="social-subtitle">Continue with your social account</p>
            <div className="social-buttons">
              <button type="button" className="social-btn">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/2048px-Microsoft_logo.svg.png"
                  alt="Microsoft"
                />
                Continue With Microsoft
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrganizationRegister;
